import type { BilingualText } from "@core/types";
import type { ContentLanguage } from "./LanguageSwitch";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): BenefitsScreen.tsx y
// RewardsScreen.tsx resolvían el mismo objeto bilingüe `{es, en}` al idioma
// de edición con una función local idéntica palabra por palabra. Extracción
// sin cambio de comportamiento ni de valores visuales.
export function resolveBilingualText(
  value: BilingualText | string | undefined | null,
  lang: ContentLanguage,
) {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value[lang] ?? "";
}
